<template>
  <div :class="'status status-'+color">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "Status",
  components: {},
  props: {
    color: String
  },
  data() {
    return {};
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
@use "@/assets/scss/vars.scss" as *;
.status {
  padding: 5px 10px;
  text-align: center;
  border-radius: 100px;
  max-width: 150px;
  &-green {
    color: white;
    background-color: $gray-6;
    font-size: 12px;
    font-weight: bold;
  }
  &-red {
    color: $red-3;
    background-color: $red-4;
  }
}
</style>
